exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-word-wrap {\n  word-wrap: break-word;\n}\n\n\n.panel-heading-slim {\n  padding: 4px 15px;\n}\n\n.center-text {\n  padding-top: 5px;\n}\n\n.thin {\n  font-weight: normal\n}\n\n.text-left {\n  text-align: left;\n}\n\n.margin-right-slim {\n  margin-right: 6px;\n}\n\n.form-control.ng-valid[required] {\n  border-left: 5px solid #42A948;\n}\n\n.form-control.ng-invalid.ng-dirty {\n  border-left: 5px solid #a94442;\n}\n\n.padding-top-0 {\n  padding-top: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/constructs/constructs-details/constructs-questions/constructs-questions.component.css
// module id = ../../../../../src/app/modules/constructs/constructs-details/constructs-questions/constructs-questions.component.css
// module chunks = main